// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-big[data-v-98c6b3b6]{width:100%;height:4.8rem;font-size:1.4667rem;font-weight:400}", ""]);
// Exports
module.exports = exports;
